// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-diet-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  
  .diet-section {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1300px;
    gap: 120px; 
  }
  
  .diet-left, .diet-right {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .history-dropdown-group {
    display: flex;
    gap: 8px; 
    justify-content: center; 
  }

  .history-dropdown-group .styled-dropdownnn {
    width: 92%;
    max-width: 307px;
  }

  .history-dropdown-group .template-dropdown {
    width: 60%;
    max-width: 280px;
  }

  h2 {
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  
  .dropdown-group {
    display: flex;
    width: 40%;
    gap: 20px; 
  }
  
  .styled-dropdownnn {
    flex: 1 1;
    padding: 10px;
    border-radius: 12px;
    border: 1px solid #ccc;
    font-size: 16px;
    min-width: 307px;
    width: 92%;
  }
  
  .diet-input {
    width: 100%;
    height: 350px;
    background-color: #A5D6A7;
    border-radius: 12px;
    padding: 15px;
    font-size: 16px;
    margin-top: 20px;
    resize: none;
    border: 1px solid black;
    font-family: 'Rubik', sans-serif;
  }
  
  .diet-right .button-group1 {
    margin-top: 30px; 
    display: flex;
    gap: 15px;
    width: 30%;
  }
  
  .edit-butn {
    margin-top: 30px;
    width: 100px; 
    padding: 10px 15px;
    /* margin-left: -50px;  */
    height: 45px;
    font-size: 16px; 
    border-radius: 12px; 
    text-align: center; 
    transition: background 0.3s ease; 
  }
  
  .diet-input-scrollable {
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none; 
  }
  
  .diet-input-scrollable::-webkit-scrollbar {
    width: 0px;
  }

  .edit-butn { background-color: #FFA500; color: white; }
  
  .edit-btn:hover { background-color: #e69500; }

  .diet-input-container {
    height: 350px;
    margin-bottom: 10px;
    width: 100%;
  }
  
  .rich-editor {
    height: 100%;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    font-family: 'Rubik', sans-serif;
  }
  
  .rich-editor .ql-container {
    font-size: 16px;
    height: calc(100% - 42px); 
    overflow-y: auto;
    font-family: 'Rubik', sans-serif;
  }
  
  .view-only .ql-container {
    height: 100%;
    font-size: 16px;
    font-family: 'Rubik', sans-serif;
  }
  
  .view-only .ql-toolbar {
    display: none;
  }
  
  .view-only .ql-container {
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .button-group1 {
    display: flex;
    flex-direction: row; 
    align-items: center; 
    gap: 15px;
    margin-top: 20px;
    justify-content: flex-start !important;
    width: fit-content; 
  }
  
  .save-btn, .cancel-btn {
    margin-top: 40px !important;
    width: 120px;
    height: 45px;
    padding: 0;
    font-size: 16px;
    border-radius: 12px;
    transition: background 0.3s ease;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-family: 'Rubik', sans-serif;
    display: inline-flex; 
    align-items: center;
    justify-content: center;
    white-space: nowrap; 
  }
  
  .diet-left .save-btn,
  .diet-left .cancel-btn {
    margin-top: 0;
    vertical-align: top; 
  }
  
  .save-btn {
    background-color: #4CAF50;
    color: white;
  }
  
  .save-btn:hover {
    background-color: #45a049;
  }
  
  .cancel-btn {
    background-color: #f44336;
    color: white;
  }
  
  .cancel-btn:hover {
    background-color: #d32f2f;
  }
  
  .save-btn:not(.button-group1 .save-btn),
  .cancel-btn:not(.button-group1 .cancel-btn) {
    all: unset;
  }

  .success-message-container {
    position: fixed;
    top: 70px; 
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none; 
  }
  
.success-message11 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-messag11 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}
  
  @keyframes fadeInOut {
    0% { opacity: 0; transform: translateY(-20px); }
    10% { opacity: 1; transform: translateY(0); }
    90% { opacity: 1; transform: translateY(0); }
    100% { opacity: 0; transform: translateY(-20px); }
  }  `, "",{"version":3,"sources":["webpack://./src/styles/CreateDietPage.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,UAAU;IACV,SAAS;EACX;;EAEA;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA,aAAa,yBAAyB,EAAE,YAAY,EAAE;;EAEtD,kBAAkB,yBAAyB,EAAE;;EAE7C;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;;AAEF;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;EAEE;IACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;IAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;IAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;IAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACnD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600&display=swap');\n\n.create-diet-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n  }\n  \n  .diet-section {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 1300px;\n    gap: 120px; \n  }\n  \n  .diet-left, .diet-right {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .history-dropdown-group {\n    display: flex;\n    gap: 8px; \n    justify-content: center; \n  }\n\n  .history-dropdown-group .styled-dropdownnn {\n    width: 92%;\n    max-width: 307px;\n  }\n\n  .history-dropdown-group .template-dropdown {\n    width: 60%;\n    max-width: 280px;\n  }\n\n  h2 {\n    margin-bottom: 10px;\n    font-size: 24px;\n    font-weight: bold;\n    color: #333;\n  }\n  \n  .dropdown-group {\n    display: flex;\n    width: 40%;\n    gap: 20px; \n  }\n  \n  .styled-dropdownnn {\n    flex: 1;\n    padding: 10px;\n    border-radius: 12px;\n    border: 1px solid #ccc;\n    font-size: 16px;\n    min-width: 307px;\n    width: 92%;\n  }\n  \n  .diet-input {\n    width: 100%;\n    height: 350px;\n    background-color: #A5D6A7;\n    border-radius: 12px;\n    padding: 15px;\n    font-size: 16px;\n    margin-top: 20px;\n    resize: none;\n    border: 1px solid black;\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .diet-right .button-group1 {\n    margin-top: 30px; \n    display: flex;\n    gap: 15px;\n    width: 30%;\n  }\n  \n  .edit-butn {\n    margin-top: 30px;\n    width: 100px; \n    padding: 10px 15px;\n    /* margin-left: -50px;  */\n    height: 45px;\n    font-size: 16px; \n    border-radius: 12px; \n    text-align: center; \n    transition: background 0.3s ease; \n  }\n  \n  .diet-input-scrollable {\n    overflow-y: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none; \n  }\n  \n  .diet-input-scrollable::-webkit-scrollbar {\n    width: 0px;\n  }\n\n  .edit-butn { background-color: #FFA500; color: white; }\n  \n  .edit-btn:hover { background-color: #e69500; }\n\n  .diet-input-container {\n    height: 350px;\n    margin-bottom: 10px;\n    width: 100%;\n  }\n  \n  .rich-editor {\n    height: 100%;\n    width: 100%;\n    font-size: 16px;\n    font-weight: 500;\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .rich-editor .ql-container {\n    font-size: 16px;\n    height: calc(100% - 42px); \n    overflow-y: auto;\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .view-only .ql-container {\n    height: 100%;\n    font-size: 16px;\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .view-only .ql-toolbar {\n    display: none;\n  }\n  \n  .view-only .ql-container {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n\n  .button-group1 {\n    display: flex;\n    flex-direction: row; \n    align-items: center; \n    gap: 15px;\n    margin-top: 20px;\n    justify-content: flex-start !important;\n    width: fit-content; \n  }\n  \n  .save-btn, .cancel-btn {\n    margin-top: 40px !important;\n    width: 120px;\n    height: 45px;\n    padding: 0;\n    font-size: 16px;\n    border-radius: 12px;\n    transition: background 0.3s ease;\n    border: none;\n    cursor: pointer;\n    font-weight: 500;\n    font-family: 'Rubik', sans-serif;\n    display: inline-flex; \n    align-items: center;\n    justify-content: center;\n    white-space: nowrap; \n  }\n  \n  .diet-left .save-btn,\n  .diet-left .cancel-btn {\n    margin-top: 0;\n    vertical-align: top; \n  }\n  \n  .save-btn {\n    background-color: #4CAF50;\n    color: white;\n  }\n  \n  .save-btn:hover {\n    background-color: #45a049;\n  }\n  \n  .cancel-btn {\n    background-color: #f44336;\n    color: white;\n  }\n  \n  .cancel-btn:hover {\n    background-color: #d32f2f;\n  }\n  \n  .save-btn:not(.button-group1 .save-btn),\n  .cancel-btn:not(.button-group1 .cancel-btn) {\n    all: unset;\n  }\n\n  .success-message-container {\n    position: fixed;\n    top: 70px; \n    left: 0;\n    right: 0;\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none; \n  }\n  \n.success-message11 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-messag11 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n  \n  @keyframes fadeInOut {\n    0% { opacity: 0; transform: translateY(-20px); }\n    10% { opacity: 1; transform: translateY(0); }\n    90% { opacity: 1; transform: translateY(0); }\n    100% { opacity: 0; transform: translateY(-20px); }\n  }  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
